import { useEffect, useState } from "react";
import axios from "axios";
import { ExternalLink } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ListenAnywhere() {
  const [directories, setDirectories] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/listen-platforms`);
        setDirectories(res.data.directories || []);
      } catch (e) {
        /* silent */
      }
    };
    load();
  }, []);

  const validDirectories = directories.filter((d) => !d.truncated);

  return (
    <section
      id="listen-anywhere"
      className="relative border-t border-zinc-800 bg-zinc-950"
      data-testid="listen-anywhere-section"
    >
      <div className="px-4 md:px-10 py-12 md:py-20">
        {/* Heading */}
        <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
          <div>
            <div className="text-xs tracking-[0.4em] text-zinc-300 uppercase mb-3">
              //_LISTEN_ANYWHERE
            </div>
            <h2 className="font-display text-5xl md:text-7xl leading-none text-zinc-50 glitch">
              EVERYWHERE<span className="text-red-600">.</span>
            </h2>
          </div>
          <div className="text-sm text-zinc-300 max-w-md">
            Catch Digital Revolution Radio on your favorite radio directory
            or your kitchen smart speaker. We're on{" "}
            <span className="text-red-500">
              {validDirectories.length}+
            </span>{" "}
            platforms and counting.
          </div>
        </div>

        {/* Directory grid */}
        {validDirectories.length > 0 && (
          <>
            <div className="text-xs tracking-[0.4em] text-zinc-300 uppercase mb-4">
              //_TUNE_IN_VIA · {validDirectories.length} DIRECTORIES
            </div>
            <div
              className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 border-l border-t border-zinc-800"
              data-testid="listen-directory-grid"
            >
              {validDirectories.map((p) => (
                <DirectoryTile key={p.name} platform={p} />
              ))}
            </div>
          </>
        )}

        <p className="mt-8 text-xs text-zinc-600 tracking-widest uppercase">
          //_more platforms added regularly · signal everywhere
        </p>
      </div>
    </section>
  );
}

function DirectoryTile({ platform }) {
  return (
    <a
      href={platform.url}
      target="_blank"
      rel="noopener noreferrer"
      className="border-r border-b border-zinc-800 bg-zinc-950 hover:bg-zinc-100 text-zinc-300 hover:text-black transition-colors p-4 min-h-[80px] flex items-center justify-between gap-2 group"
      data-testid={`directory-tile-${platform.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    >
      <span className="font-display text-base md:text-lg tracking-tight uppercase leading-tight">
        {platform.name}
      </span>
      <ExternalLink className="w-3.5 h-3.5 opacity-50 group-hover:opacity-100 shrink-0" />
    </a>
  );
}
